export const TwitterSVG = () => (
  <svg
    data-testid="twitter-logo-svg"
    width={27}
    height={26}
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.6188 11.0105L25.2912 0.000244141H23L14.5979 9.55834L7.89219 0.000244141H0.156006L10.2986 14.4551L0.156006 25.9997H2.44725L11.3143 15.9038L18.3976 25.9997H26.1338M3.2742 1.69226H6.79419L22.9983 24.3908H19.4774"
      fill="black"
    />
  </svg>
)
